import { mockComponent } from 'bloko/common/setupMockComponents';

const { SuggestLayer } = jest.requireActual('bloko/blocks/suggest/SuggestPicker.js');
export { SuggestLayer };

export default mockComponent('SuggestPicker', null, {
    withChildren: true,
});
